import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Docs-Api" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-16" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Search Export")
], -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}